import { schema } from 'normalizr'

export const insuranceCompany = new schema.Entity('insuranceCompany', {}, { idAttribute: '_id' })
export const insuranceCompanyArray = new schema.Array(insuranceCompany)
